import React from "react";

const Footer = () => {
  return (
    <footer className="footer mt-5 text-light text-center py-3">
      <p>&copy; Copyright 2024. Made by <span className="highlight">Muhammad hasnain</span> </p>
    </footer>
  );
};

export default Footer;
